/**
 * Usage Configuration
 * Quản lý các config liên quan đến lượt sử dụng miễn phí
 * Lấy giá trị từ environment variables, fallback về default nếu không có
 */

// Lấy giá trị FREE_TRIAL_LIMIT từ env, fallback về 3
const FREE_TRIAL_LIMIT = parseInt(
  process.env.REACT_APP_FREE_TRIAL_LIMIT || "3",
  10
);

console.log(`✅ Free Trial Limit configured: ${FREE_TRIAL_LIMIT} lượt/ngày`);

export const USAGE_CONFIG = {
  // Số lượt miễn phí mặc định mỗi ngày
  DEFAULT_DAILY_LIMIT: FREE_TRIAL_LIMIT,
  
  // Timezone cho Việt Nam
  VN_TIMEZONE: "Asia/Ho_Chi_Minh",
};

export default USAGE_CONFIG;

